import { For, Show, onMount } from "solid-js";
import { CMS } from "../../components/cms/cms";
import { createStore } from "solid-js/store";
import { SubMenu, loadAds, loadCategoriesCms, loadCms, setPageTitle, setSubMenu } from "../../app";
import { useRouteData } from "@solidjs/router";
import { ArtworkGridItem } from "../../components/artwork-grid-item";
import { SearchArtworks, SearchEndpoint } from "../../components/search-artworks";
import { Winner } from "../../components/winner";
import { ContestWinner } from "../../Types";

type Model = {
    Category: {
        Id: string;
        Name: string;
    }
    Salon: {
        Id: string;
        Name: string;
    }
    Winners: ContestWinner[];
    HonourableMentions: ContestWinner[];
    ChairmansTeensAwards: ContestWinner[];
}
type State = {
    isContentReady: boolean;
}

export function CategoryPage() {
    const [model, setModel] = createStore<Model>({} as Model);
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    const slug = (name: string) => name.toLowerCase().replaceAll(" ", "-").trim();
    onMount(async () => {
        const routeData = await useRouteData() as any;
        setModel(routeData.model);
        await loadCategoriesCms();
        const categoryCode = slug(model.Category.Name.toLowerCase());
        await loadCms([
            "8th-arc-salon/category::" + model.Category.Name.toLowerCase()
        ]);
        await loadAds("8th-arc-salon/" + categoryCode);
        setPageTitle({ text: model.Category.Name });
        setSubMenu(model.Category.Name as SubMenu);
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <div class="category-intro">
                    <div class="container">
                        <h1>
                            {model.Category.Name}
                        </h1>
                        <div>
                            <CMS id={"8th-arc-salon/category::" + model.Category.Name.toLowerCase()}></CMS>
                        </div>
                    </div>
                </div>
                <Show when={model.Winners}>
                    <div class="category-divider">
                        <h1 style="text-align: center;">
                            <CMS text id="8th-arc-salon/category::heading/winners">Winners</CMS>
                        </h1>
                    </div>
                    <div class="winners">
                        <For each={model.Winners}>{(item) => <Winner item={item} maxHeight={600} maxWidth={600} />}</For>
                    </div>
                </Show>
                <Show when={model.HonourableMentions.length}>
                    <div class="category-divider">
                        <h1 style="text-align: center;">
                            <CMS text id="8th-arc-salon/category::heading/honorable-mentions">Honorable Mentions</CMS>
                        </h1>
                    </div>
                    <div class="winners" style="padding: 20px; text-align: center">
                        <For each={model.HonourableMentions}>{(item) =>
                            <ArtworkGridItem item={item} itemWidth={400} settings={{ ShowArtist: true }} />
                        }</For>
                    </div>
                </Show>
                <Show when={model.ChairmansTeensAwards.length}>
                    <>                        
                        <div class="category-divider">
                            <h1 style="text-align: center;">
                                <CMS text id="8th-arc-salon/category::heading/chairmans-teens-award">Chairman's Teens Award</CMS>
                            </h1>
                        </div>
                        <div class="honourable-mentions">
                            <For each={model.ChairmansTeensAwards}>{(item) => <ArtworkGridItem item={item} itemWidth={250} />}</For>
                        </div>
                    </>
                </Show>
                <div class="category-divider">
                    <h1 style="text-align: center;">
                        <CMS text id="8th-arc-salon/category::heading/finalists">Finalists</CMS>
                    </h1>
                </div>
                <div>
                    <SearchArtworks
                        filter={{ Page: 1, CategoryId: model.Category.Id, EntrantType: "Finalist" } as any}
                        settings={{ ShowArtist: true, Endpoint: SearchEndpoint.Category }}
                    />
                </div>
            </Show>
        </>
    )
}